export default function DOM_XMLHttpRequest() {
  return (
    <div>
      <h1>DOM_XMLHttpRequest</h1>
      <p>This is the DOM_XMLHttpRequest component.</p>
    </div>
  );
}